module.exports = __webpack_public_path__ + "img/third-2-opened.b4adf471.webp";